import { Dropdown } from "react-bootstrap";
import styled from "@emotion/styled";

const CustomDropdownMenu = styled(Dropdown.Menu)`
    & > .search {
        background-color: #f0f0f0 !important;
        border-color: #ced4da;
        color: #000;
    }

    .check-list {
        max-height: 300px;
        overflow-y: scroll;

        &::-webkit-scrollbar {
            width: 8px;
            background-color: #e8e8e8;
        }
        &::-webkit-scrollbar-track {
            -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
            border-radius: 8px;
            background-color: #e8e8e8;
        }
        &::-webkit-scrollbar-thumb {
            border-radius: 8px;
            -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
            background-color: #7a7a7a;
        }
    }

    @media screen and (max-width: 576px) {
        min-width: calc(100vw - 3rem);
    }

    @media screen and (max-width: 768px) {
        min-width: 18rem;
    }
`;

export default CustomDropdownMenu;
